// @packages
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// @scripts
import CandidateGridDisplay from './CandidateGridDisplay';
import {
    addItemToSchedule,
    clearCandidateProducts,
    getCandidateProducts,
    getSearchInputs
} from '../../actions';

const CandidateGridContainer = ({
    candidateProducts,
    searchInputsState,
    onAddItemToSchedule,
    onClearCandidateProducts,
    onGetCandidateProducts,
    onGetSearchInputs,
}) => (
    <CandidateGridDisplay
        candidateProducts={candidateProducts}
        searchInputsState={searchInputsState}
        id="lab-exhaust-page"
        onAddItemToSchedule={onAddItemToSchedule}
        onClearCandidateProducts={onClearCandidateProducts}
        onGetCandidateProducts={onGetCandidateProducts}
        onGetSearchInputs={onGetSearchInputs}
    />
);

CandidateGridContainer.propTypes = {
    candidateProducts: PropTypes.array.isRequired,
    searchInputsState: PropTypes.array.isRequired,
    onAddItemToSchedule: PropTypes.func.isRequired,
    onClearCandidateProducts: PropTypes.func.isRequired,
    onGetCandidateProducts: PropTypes.func.isRequired
};

CandidateGridContainer.defaultProps = {
};

const mapStateToProps = ({ product }) => ({
    candidateProducts: product.candidateProducts,
    searchInputsState: product.searchInputs
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    onAddItemToSchedule: addItemToSchedule,
    onClearCandidateProducts: clearCandidateProducts,
    onGetCandidateProducts: getCandidateProducts,
    onGetSearchInputs: getSearchInputs
}, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps
)(CandidateGridContainer);
